define.alias("shared/components/shared/wizard", "settings/components/shared/wizard");